import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCardModule,
	FreudInputNumberModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SessionsValuesModule } from 'app/my-account/components/session-values/session-values.module';

import { AddressPriceModalModule } from '../address-price-modal/address-price-modal.module';
import { AddressParticularPriceComponent } from './address-particular-price.component';

@NgModule({
	declarations: [AddressParticularPriceComponent],
	imports: [
		CommonModule,
		FreudCardModule,
		FreudButtonModule,
		FreudInputNumberModule,
		ReactiveFormsModule,
		TranslateModule,
		AddressPriceModalModule,
		SessionsValuesModule,
		FreudTooltipModule,
	],
	exports: [AddressParticularPriceComponent],
})
export class AddressParticularPriceModule {}
